export default "/_next/static/images/3c0acbefce56eb5d90fd9b033a54bed7.jpg";